<script setup lang='ts'>
import WisionLogo from '../WisionLogo.vue';
import { useRouter } from 'vue-router';
import { useAppState } from '../../store/state';
import CustomInput from '../CustomInput.vue';
import Button from '../Button.vue';
import { ref } from 'vue';
import useFieldValidation from '../../utilities/useFieldValidation';
import ScrollContainer from '../ScrollContainer.vue';
import { event } from 'vue-gtag';

const state = useAppState();
const router = useRouter();
const fieldValidation = useFieldValidation();

const companyName = ref<string | undefined>(undefined);
const orgNumber = ref<string | undefined>(undefined);
const address = ref<string | undefined>(undefined);
const zip = ref<string | undefined>(undefined);
const city = ref<string | undefined>(undefined);
const customerId = ref<string | undefined>(undefined);

const companyNameValid = fieldValidation.validation(companyName);
const addressValid = fieldValidation.validation(address);
const zipValid = fieldValidation.validation(zip);
const cityValid = fieldValidation.validation(city);

if (!state.createdUser) router.push({ name: 'start' });

const handleDone = () => {
  fieldValidation.validateAll();
  if (!fieldValidation.allFieldsValid.value) return;

  event('organization_created', { method: 'Google' });

  state.setCreatedOrganization({
    name: companyName.value as string,
    orgNumber: orgNumber.value as string,
    address: address.value as string,
    postalNumber: zip.value as string,
    location: city.value as string,
    ahlsellId: customerId.value
  });

  router.push({ name: 'terms' });
};
</script>

<template>
  <div class="flex flex-col items-center w-full text-onboard-shade2 uppercase">
    <ScrollContainer>
      <div class="flex flex-col mt-[20%] items-center">
        <WisionLogo :width="114" class="text-onboard-foreground"/>

        <span class="text-xl mt-3 text-center">
          {{ $t('nfc.startTrailPeriod') }}
        </span>

        <div class="text-center mt-2 leading-none">
          <span class="text-sm">
            {{ $t('nfc.experienceWision') }}
          </span>
        </div>
      </div>

      <div class="flex flex-col mt-3 items-center text-center">
        <span class="text-xl mt-2">
          {{ $t('nfc.connectOrg') }}
        </span>
      </div>

      <div class="w-full">
        <div class="w-full mt-5 flex gap-5 flex-col">
          <CustomInput :valid="companyNameValid" class="h-12" :placeholder="$t('nfc.form.companyName').toUpperCase()" v-model="companyName"></CustomInput>
          <CustomInput :valid="addressValid" class="h-12" :placeholder="$t('nfc.form.companyAddress').toUpperCase()" v-model="address"></CustomInput>
          <div class="grid grid-cols-2 gap-3">
            <CustomInput :valid="zipValid" class="h-12" :placeholder="$t('nfc.form.zip').toUpperCase()" v-model="zip"></CustomInput>
            <CustomInput :valid="cityValid" class="h-12" :placeholder="$t('common.city').toUpperCase()" v-model="city"></CustomInput>
          </div>
          <CustomInput class="mt-6 h-12" :placeholder="$t('nfc.form.ahlsellId').toUpperCase()" v-model="customerId"></CustomInput>
          <CustomInput class="h-12" :placeholder="$t('nfc.form.orgNumber').toUpperCase()" v-model="orgNumber"></CustomInput>

        </div>
        <Button :valid="companyNameValid" class="mt-6 h-12" @click="handleDone()">
          KLAR
        </Button>
      </div>
    </ScrollContainer>
    <span class="text-onboard-shade1 pt-5 pb-3 mt-auto text-center">WISION BUILD {{ state.build }}</span>
  </div>
</template>
